import { useQuery } from "@apollo/client";
import type {
  DataSourcesSlowInfoResponse,
  UseIntegratedDataSourcesSlowInfoResult,
} from "./types";
import { GET_DATA_SOURCES_SLOW_INFO } from "./APIs/DataSourcesApi";

const useIntegratedDataSourcesSlowInfo = (
  useCache = false
): UseIntegratedDataSourcesSlowInfoResult => {
  const {
    data: integratedDataSourcesSlowInfo,
    error: integratedDataSourcesSlowInfoError,
    loading: integratedDataSourcesSlowInfoLoading,
  } = useQuery<DataSourcesSlowInfoResponse>(GET_DATA_SOURCES_SLOW_INFO, {
    fetchPolicy: useCache ? "cache-first" : "no-cache",
  });

  return {
    integratedDataSourcesSlowInfo,
    integratedDataSourcesSlowInfoError,
    integratedDataSourcesSlowInfoLoading,
  };
};

export default useIntegratedDataSourcesSlowInfo;
